import LoadingContainer from 'components/common/LoadingContainer';
import PropTypes from 'prop-types';
import { createContext, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { useBeneficiary } from 'hooks/useBeneficiaries';

export const BeneficiaryContext = createContext({
  beneficiary: null
});

export function BeneficiaryContextProvider({ children }) {
  const { id } = useParams();
  const { beneficiary, isLoading } = useBeneficiary(id);

  return (
    <BeneficiaryContext.Provider
      value={{
        beneficiary: beneficiary ?? {}
      }}
    >
      {isLoading ? <LoadingContainer /> : children}
    </BeneficiaryContext.Provider>
  );
}

BeneficiaryContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const useBeneficiaryContext = () => {
  const context = useContext(BeneficiaryContext);
  if (context === undefined) {
    throw new Error(
      'useDonorContext must be used within a BeneficiaryContextProvider'
    );
  }
  return context;
};

export default BeneficiaryContext;
